import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { motion } from "framer-motion"; // For animations
import empty_box from "../../images/empty_box.png";
import Client from "../../utils/client";
import Skelton from "../../icons/skelton"; // Assuming this is your Skeleton loader

const Negotiations = () => {
    const [selectedNegotiation, setSelectedNegotiation] = useState(null);

    // Fetch negotiations with last messages
    const { data: negotiations, isFetching } = useQuery({
        queryKey: ["negotiations"],
        queryFn: async () => {
            const response = await Client.get("/negotiations/last-messages").then(
                (res) => res.data
            );
            return response;
        },
        initialData: [],
    });

    return (
        <div className="w-full px-4 lg:px-20 relative">
            <h1 className="text-end font-bold text-2xl lg:text-3xl my-10 text-primary">
                الرسائل
            </h1>
            {isFetching ? (
                <div dir="rtl" className="my-16 grid grid-cols-1 gap-4 px-0 lg:grid-cols-1 lg:mr-8">
                    {[...Array(5).keys()].map((_, i) => (

                        <div className="flex flex-row-reverse items-center justify-between gap-3 p-4 bg-gray-100 border rounded-xl shadow-sm animate-pulse">
                            <div className="flex flex-col text-right w-full">
                                <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div> {/* Title */}
                                <div className="h-3 bg-gray-300 rounded w-1/2"></div> {/* Last message */}
                            </div>
                            <div className="h-3 bg-gray-300 rounded w-16"></div> {/* Date */}
                        </div>
                    ))}
                </div>
            ) : negotiations?.length === 0 ? (
                <div className="flex flex-col col-span-2 mt-10 justify-center items-center text-center lg:col-span-5">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.4 }}
                    >
                        <img
                            src={empty_box}
                            alt="No Negotiations"
                            className="w-40 lg:w-48"
                        />
                    </motion.div>
                    <div className="font-bold mt-3 text-lg text-gray-700">
                        لا توجد رسائل
                    </div>
                </div>
            ) : (
                <div className="flex flex-col gap-4">
                    {negotiations?.map((negotiation) => (
                        <motion.div
                            key={negotiation.id}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3, delay: 0.1 * negotiations.indexOf(negotiation) }}
                        >
                            <Link
                                to={`/home/negotiation/${negotiation.id}`}
                                onClick={() => setSelectedNegotiation(negotiation.id)}
                                className={`
                flex flex-row-reverse items-center text-right justify-between gap-1 md:gap-3 p-2 md:p-4 
                rounded-xl shadow-sm transition-all hover:shadow-md hover:scale-[1.02]
                ${negotiation.unreadCount > 0 ? 'bg-blue-50 border-blue-400' : 'bg-white border-gray-200'}
                ${selectedNegotiation === negotiation.id ? 'border-primary' : ''}
            `}
                            >
                                {/* Square Image */}
                                <div className="flex-shrink-0 relative">
                                    <img
                                        src={negotiation.imageUrl}
                                        alt="Negotiation"
                                        className="w-14 h-14 rounded-xl object-cover border border-gray-200"
                                    />
                                    {negotiation.unreadCount > 0 && (
                                        <div className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                                            {negotiation.unreadCount}
                                        </div>
                                    )}
                                </div>

                                <div dir="rtl" className="flex flex-col text-right w-full">
                                    <div className="font-bold text-lg text-gray-800">
                                        {negotiation.title}
                                    </div>
                                    <div className={`text-right  text-sm ${negotiation.unreadCount > 0 ? 'text-black font-semibold' : 'text-gray-500'}`}>
                                        {/* For Mobile: Shorter message length */}
                                        <span className="block truncate max-w-[150px] md:hidden">
                                            {negotiation.lastMessage}
                                        </span>

                                        {/* For Desktop: Longer message length */}
                                        <span className="hidden truncate max-w-[300px] md:block">
                                            {negotiation.lastMessage}
                                        </span>
                                    </div>
                                </div>

                                <div className="text-sm text-gray-400">
                                    {new Date(negotiation.updatedAt).toLocaleDateString("ar-EG", {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                    })}
                                </div>
                            </Link>
                        </motion.div>
                    ))}

                </div>
            )}
        </div>
    );
};

export default Negotiations;
